(function (){
    'use strict';

    angular
        .module('services')
        .service('SurveyService', SurveyService);

    SurveyService.$inject = ['$http', 'API_BASE'];

    function SurveyService ($http, API_BASE) {
        var service = this;

        service.getSurveys   = getSurveys;
        service.getSurveys2  = getSurveys2;
        service.getStats     = getStats;

        function getSurveys() {
            return $http.get(API_BASE + '/surveys/all');

        }

        function getSurveys2(filters) {
            return $http.get(API_BASE + '/esurveys/all', {params: filters});

        }

        function getStats(filters) {
            return $http.get(API_BASE + '/esurveys/' + filters['survey_id'] + '/stats', {params: filters});

        }
        
    }
})();